export default __webpack_public_path__ + "static/media/Homepage_hero.0bc1e304.webp";